import { useRef } from "react";
import { FaBars } from "react-icons/fa";
import { AiFillCaretDown } from "react-icons/ai";
import "./Menu.css";
import * as React from 'react';
import Button from '@mui/material/Button';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import MenuItem from '@mui/material/MenuItem';


function Navbar() {
  const navRef = useRef();

  const showNavbar = () => {
    navRef.current.classList.toggle("responsive_nav");
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const theme = createTheme();

  theme.typography.h3 = {}

  return (
    <header>
      <div className="NavLogo">
        <img src="../../assets/logo.jpeg" alt="logo Cia Canoinhas" />
      </div>
      <div className="navBtn">
        <nav ref={navRef}>
          <a href="/#">Home</a>
          <a href="/sobre">A Empresa</a>
          <ThemeProvider theme={theme}>
            <Button
              sx={{
                fontFamily: "'Roboto', 'sans-serif'",
                textTransform: "none",
                fontSize: "16px",
                color: "#475B65",
                '&:hover, &.Mui-focusVisible': {
                  backgroundColor: 'transparent',
                  transform: 'none'
                },
              }}
              id=""
              aria-controls={open ? 'demo-positioned-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
            >
              <a>Produtos</a> <AiFillCaretDown />
            </Button>
            <Menu
              id="demo-positioned-menu"
              aria-labelledby=""
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              <MenuItem onClick={handleClose}><a style={{ textDecoration: "none", fontWeight: "400", color: "#475B65" }} href="/fofinho">Fofinho</a></MenuItem>
              <MenuItem onClick={handleClose}><a style={{ textDecoration: "none", fontWeight: "400", color: "#475B65" }} href="/fofinhoAbsolut">Fofinho Absolute</a></MenuItem>
              <MenuItem onClick={handleClose}><a style={{ textDecoration: "none", fontWeight: "400", color: "#475B65" }} href="/fofinhoAbsolutPremium">fofinho Absolute Premium</a></MenuItem>
              <MenuItem onClick={handleClose}><a style={{ textDecoration: "none", fontWeight: "400", color: "#475B65" }} href="/sorella">Sorella</a></MenuItem>
              <MenuItem onClick={handleClose}><a style={{ textDecoration: "none", fontWeight: "400", color: "#475B65" }} href="/best">Best</a></MenuItem>
              <MenuItem onClick={handleClose}><a style={{ textDecoration: "none", fontWeight: "400", color: "#475B65" }} href="/bambino">Bambino</a></MenuItem>
            </Menu>
          </ThemeProvider>
          <a href="/#">Notícias</a>
          <a href="/faleConosco">Fale Conosco</a>
          <a className="bold" href="https://painel.umentor.com.br/inteligente_novos/?con_cod=cia44509&pla=5">Trabalhe Conosco</a>
        </nav>
        <button className="nav-btn" onClick={showNavbar}>
          <FaBars />
        </button>
      </div>
    </header>
  );
}

export default Navbar;